import { useContext, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { getCanViewLuxPlusBenefits, getIsEligibleLuxPlusFreePreview } from 'luxPlus/selectors/featureToggle'
import { pushWithRegion } from 'actions/NavigationActions'
import offerPageURL from 'lib/offer/offerPageURL'
import LuxPlusFreePreviewModal from '../modals/LuxPlusFreePreviewModal'
import Modal from 'LuxKit/Modal/Modal'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import styled from 'styled-components'
import { rem } from 'polished'

const StyledLoadingIndicator = styled(LoadingIndicator)`
min-height: ${rem(200)};
`

interface MappedProps {
  isLoggedIn: boolean
  isEligibleForFreePreview: boolean
  canViewLuxPlusBenefits: boolean
  isLoadingEligibilityOrSubscription: boolean
}

interface Props extends MappedProps {
  offer: App.Offer | App.OfferSummary
}

function LuxPlusHiddenOfferTransitionModal(props: Props) {
  const { offer, isEligibleForFreePreview, canViewLuxPlusBenefits, isLoadingEligibilityOrSubscription } = props

  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()
  const context = useModalElementContext()
  useEffect(() => {
    if (isLoadingEligibilityOrSubscription) return
    context.resolve()
    if (!canViewLuxPlusBenefits) {
      showModal(<LuxPlusFreePreviewModal />)
    } else {
      dispatch(pushWithRegion(offerPageURL(offer)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEligibleForFreePreview, canViewLuxPlusBenefits, isLoadingEligibilityOrSubscription])

  const loadingTitle = intl.formatMessage({
    id: '6TC2g4WtK-e2jVPmWwr9',
    defaultMessage: 'Loading',
    description: 'Title for the loading modal while transitioning to a LuxPlus hidden offer',
  })

  return <Modal title={loadingTitle}>
    <StyledLoadingIndicator floating visible />
  </Modal>
}

const mapStateToProps = (state: App.State): MappedProps => ({
  isLoggedIn: selectLoggedIn(state),
  isEligibleForFreePreview: getIsEligibleLuxPlusFreePreview(state),
  canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
  isLoadingEligibilityOrSubscription: state.luxPlus.products.freePreview.fetching || state.auth.account.luxPlus.member.subscription.fetching,
})

export default connect(mapStateToProps)(LuxPlusHiddenOfferTransitionModal)
